/**
 * FRAGRANCE_QUIZ_PROFILES (B2C)
 * Profile texts for the Heinsson Scent Trinity™ Profiler (v6, B2C version).
 * Consumed by the B2C quiz JS — no module syntax, plain global assignment.
 *
 * German is the source. The English set is selected at runtime via window.FQ_LANG
 * (set by the section Liquid from request.locale). US English follows the
 * Heinsson tonality: no exclamation marks, no dashes, direct "you" address.
 *
 * Structure:
 *   intro         — per-family opening text (16 families, Mensing wheel v6)
 *   bridge        — primary → secondary connector (Trio-System: direct neighbors)
 *   presence      — spatial presence modifier (4 levels)
 */

window.FRAGRANCE_QUIZ_PROFILES_DE = {

  intro: {

    'fruchtig':
      'Dein Duft ist purer Genuss: saftig, reif und leuchtend. Er weckt sofort Freude ' +
      'und trägt die Leichtigkeit eines unverhofften Moments. Lebensfroh und unbeschwert.',

    'zitrisch':
      'Dein Duft kommt sofort an: spritzig und prickelnd, mit einer befreienden Helligkeit. ' +
      'Der Tag öffnet sich. Optimistisch, wach und aufgeschlossen.',

    'aromatisch':
      'Dein Duft riecht nach zerriebenen Kräutern zwischen den Fingern: krautig, botanisch ' +
      'und mit einer Direktheit, die sofort wach macht. Fokussiert und tatkräftig.',

    'aquatisch':
      'Dein Duft trägt die Weite des Meeres in sich: wässrig, maritim, mit einer ' +
      'mineralischen Klarheit, die den Kopf frei macht. Befreit und ausgeglichen.',

    'frisch':
      'Dein Duft ist Reinheit: kühl, kristallin und puristisch. Er begleitet ohne Umschweife. ' +
      'Erfrischt, leicht und gelöst.',

    'floral-klar':
      'Dein Duft ist Luft selbst: luftig, transparent und schwebend. Heiter, ungezwungen ' +
      'und völlig entspannt.',

    'gruen':
      'Dein Duft ist der erste Atemzug im Garten: grün, blättrig und knackig. ' +
      'Zuversichtlich, erholt und geerdet.',

    'floral':
      'Dein Duft hat die Eleganz von Blüten: blumig, elegant und betörend. ' +
      'Anmutig, zärtlich und herzlich.',

    'pudrig':
      'Dein Duft legt sich wie ein weicher Mantel um die Schultern: pudrig, samtig und weich. ' +
      'Sanftmütig, friedlich und ruhig.',

    'floriental':
      'Dein Duft ist sinnlich und verlockend: üppig, berauschend und opulent. ' +
      'Sinnlich, magnetisch und hingebungsvoll.',

    'milch-moschus':
      'Dein Duft ist der kürzeste Abstand zwischen dir und der Welt: milchig, cremig und hautnah. ' +
      'Geborgen, behütet und beschützt.',

    'gourmand':
      'Dein Duft ist Verwöhnung: süß, vanillig und sirupartig. ' +
      'Genussvoll, verspielt und verwöhnt.',

    'orientalisch':
      'Dein Duft ist ein Statement: harzig, balsamisch und orientalisch. ' +
      'Geheimnisvoll, tiefgründig und versunken.',

    'wuerzig':
      'Dein Duft hat Kraft: pfeffrig, wärmend und feurig. ' +
      'Selbstsicher, mutig und entschlossen.',

    'holzig':
      'Dein Duft hat Substanz: trocken, warm und rauchig. ' +
      'Stabil, standhaft und zentriert.',

    'chypre':
      'Dein Duft hat die Kraft der Stille: herb, moosig und chypre. ' +
      'Souverän, selbstbestimmt und charismatisch.',
  },

  bridge: {

    'fruchtig→chypre':
      'Das Erdig-Ledrige gibt deinem fruchtigen Genuss eine souveräne, charismatische Tiefe.',
    'fruchtig→zitrisch':
      'Das Zitrische bricht die Fruchtigkeit mit spritziger, befreiender Helligkeit.',

    'zitrisch→fruchtig':
      'Die Fruchtigkeit gibt deiner Spritzigkeit eine lebensfreudige, unbeschwerte Wärme.',
    'zitrisch→aromatisch':
      'Das Aromatische öffnet die Spritzigkeit um eine fokussierte, tatkräftige Botanik.',

    'aromatisch→zitrisch':
      'Das Zitrische gibt deiner Botanik eine optimistische, aufgeschlossene Leichtigkeit.',
    'aromatisch→aquatisch':
      'Das Aquatische öffnet deine Kraft um eine maritime, befreiende Weite.',

    'aquatisch→aromatisch':
      'Das Aromatische gibt deiner Klarheit einen fokussierten, vitalen Kern.',
    'aquatisch→frisch':
      'Das Frische gibt deiner Klarheit eine kristalline, puristische Leichtigkeit.',

    'frisch→aquatisch':
      'Das Aquatische gibt deiner Reinheit eine befreite, ausgeglichene Weite.',
    'frisch→floral-klar':
      'Das Floral-klare gibt deiner Kühlheit eine luftige, schwebende Transparenz.',

    'floral-klar→frisch':
      'Das Frische gibt deiner Luftigkeit eine erfrischt, gelöste Klarheit.',
    'floral-klar→gruen':
      'Das Grüne gibt deiner Transparenz eine zuversichtliche, geerdetete Frische.',

    'gruen→floral-klar':
      'Das Floral-klare gibt deiner Grünheit eine heitere, ungezwungene Leichtigkeit.',
    'gruen→floral':
      'Das Florale gibt deiner Knackigkeit eine anmutige, zärtliche Eleganz.',

    'floral→gruen':
      'Das Grüne gibt deiner Eleganz eine zuversichtliche, erholte Erdung.',
    'floral→pudrig':
      'Das Pudrige gibt deiner Anmut eine sanftmütige, friedliche Wärme.',

    'pudrig→floral':
      'Das Florale gibt deiner Sanftheit eine anmutige, herzliche Eleganz.',
    'pudrig→floriental':
      'Das Floriental vertieft deine Ruhe um eine sinnliche, magnetische Dimension.',

    'floriental→pudrig':
      'Das Pudrige trägt deine Sinnlichkeit in eine sanftmütige, friedliche Harmonie.',
    'floriental→milch-moschus':
      'Das Milchige gibt deiner Opulenz eine cremige, vertraute Intimität.',

    'milch-moschus→floriental':
      'Das Floriental umhüllt deine Geborgenheit mit einer üppigen, magnetischen Wärme.',
    'milch-moschus→gourmand':
      'Das Gourmand gibt deiner Cremigkeit eine genussvolle, verspielte Verwöhnung.',

    'gourmand→milch-moschus':
      'Das Milchige gibt deinem Genuss eine geborgene, behütete Weichheit.',
    'gourmand→orientalisch':
      'Das Amber gibt deiner Süße eine geheimnisvolle, tiefgründige Tiefe.',

    'orientalisch→gourmand':
      'Das Gourmand gibt deiner Tiefe eine genussvolle, verspielte Wärme.',
    'orientalisch→wuerzig':
      'Das Würzige gibt deinem Geheimnis eine selbstsichere, mutige Kraft.',

    'wuerzig→orientalisch':
      'Das Amber verleiht deiner Selbstsicherheit eine geheimnisvolle, versunkene Resonanz.',
    'wuerzig→holzig':
      'Das Holzige gibt deinem Mut eine stabile, standhaft zentrierte Basis.',

    'holzig→wuerzig':
      'Das Würzige gibt deiner Stabilität eine selbstsichere, entschlossene Kante.',
    'holzig→chypre':
      'Das Erdig-Ledrige gibt deiner Substanz eine souveräne, charismatische Präsenz.',

    'chypre→holzig':
      'Das Holzige vertieft deine Souveränität um eine stabile, zentrierte Solidität.',
    'chypre→fruchtig':
      'Das Fruchtige rundet deine Charisma um eine lebensfreudige, ausgelassene Wärme.',
  },

  presence: {
    'intim':
      'Dein Duft gehört nur dir: ein Geheimnis auf der Haut, das nur diejenigen wahrnehmen, ' +
      'die wirklich nah kommen.',

    'moderat':
      'Dein Duft ist eine stille Signatur: spürbar für die, die nah genug kommen.',

    'intensiv':
      'Dein Duft ist eine Anwesenheit. Wer dir begegnet, wird ihn wahrnehmen ' +
      'und so schnell auch nicht vergessen.',

    'statement':
      'Dein Duft definiert den Raum, noch bevor das erste Wort fällt. ' +
      'Deine olfaktorische Ansage.',
  },

};

window.FRAGRANCE_QUIZ_PROFILES_EN = {

  intro: {

    'fruchtig':
      'Your scent is pure pleasure: juicy, ripe and radiant. It sparks joy at once ' +
      'and carries the lightness of an unexpected moment. Full of life and free.',

    'zitrisch':
      'Your scent lands instantly: zesty and sparkling, with a liberating brightness. ' +
      'The day opens up. Optimistic, awake and open.',

    'aromatisch':
      'Your scent smells of herbs crushed between your fingers: herbal, botanical ' +
      'and direct enough to wake you on the spot. Focused and driven.',

    'aquatisch':
      'Your scent carries the openness of the sea: watery, marine, with a ' +
      'mineral clarity that clears your head. Liberated and balanced.',

    'frisch':
      'Your scent is purity: cool, crystalline and pared back. It stays with you, no detours. ' +
      'Refreshed, light and at ease.',

    'floral-klar':
      'Your scent is air itself: airy, translucent and weightless. Serene, easygoing ' +
      'and completely relaxed.',

    'gruen':
      'Your scent is the first breath in the garden: green, leafy and crisp. ' +
      'Confident, restored and grounded.',

    'floral':
      'Your scent has the elegance of blossoms: flowery, elegant and captivating. ' +
      'Graceful, tender and warm.',

    'pudrig':
      'Your scent settles like a soft coat around your shoulders: powdery, velvety and soft. ' +
      'Gentle, peaceful and calm.',

    'floriental':
      'Your scent is sensual and inviting: lush, intoxicating and opulent. ' +
      'Sensual, magnetic and devoted.',

    'milch-moschus':
      'Your scent is the shortest distance between you and the world: milky, creamy and close to the skin. ' +
      'Secure, sheltered and protected.',

    'gourmand':
      'Your scent is indulgence: sweet, vanilla and syrupy. ' +
      'Indulgent, playful and pampered.',

    'orientalisch':
      'Your scent is a statement: resinous, balsamic and oriental. ' +
      'Mysterious, profound and absorbed.',

    'wuerzig':
      'Your scent has force: peppery, warming and fiery. ' +
      'Self-assured, bold and determined.',

    'holzig':
      'Your scent has substance: dry, warm and smoky. ' +
      'Stable, steadfast and centered.',

    'chypre':
      'Your scent holds the power of stillness: bracing, mossy and chypre. ' +
      'Commanding, self-determined and charismatic.',
  },

  bridge: {

    'fruchtig→chypre':
      'The earthy-leather note lends your fruity pleasure a commanding, charismatic depth.',
    'fruchtig→zitrisch':
      'The citrus breaks the fruit open with a zesty, liberating brightness.',

    'zitrisch→fruchtig':
      'The fruit gives your zest a joyful, carefree warmth.',
    'zitrisch→aromatisch':
      'The aromatic opens your zest into a focused, driven botany.',

    'aromatisch→zitrisch':
      'The citrus gives your botany an optimistic, open lightness.',
    'aromatisch→aquatisch':
      'The aquatic opens your force into a marine, liberating expanse.',

    'aquatisch→aromatisch':
      'The aromatic gives your clarity a focused, vital core.',
    'aquatisch→frisch':
      'The fresh gives your clarity a crystalline, pared-back lightness.',

    'frisch→aquatisch':
      'The aquatic gives your purity a liberated, balanced expanse.',
    'frisch→floral-klar':
      'The sheer floral gives your coolness an airy, weightless translucence.',

    'floral-klar→frisch':
      'The fresh gives your airiness a refreshed, easy clarity.',
    'floral-klar→gruen':
      'The green gives your translucence a confident, grounded freshness.',

    'gruen→floral-klar':
      'The sheer floral gives your green a serene, easygoing lightness.',
    'gruen→floral':
      'The floral gives your crispness a graceful, tender elegance.',

    'floral→gruen':
      'The green gives your elegance a confident, restored grounding.',
    'floral→pudrig':
      'The powdery gives your grace a gentle, peaceful warmth.',

    'pudrig→floral':
      'The floral gives your softness a graceful, warm elegance.',
    'pudrig→floriental':
      'The floriental deepens your calm into a sensual, magnetic dimension.',

    'floriental→pudrig':
      'The powdery carries your sensuality into a gentle, peaceful harmony.',
    'floriental→milch-moschus':
      'The milky gives your opulence a creamy, familiar intimacy.',

    'milch-moschus→floriental':
      'The floriental wraps your sense of security in a lush, magnetic warmth.',
    'milch-moschus→gourmand':
      'The gourmand gives your creaminess an indulgent, playful sweetness.',

    'gourmand→milch-moschus':
      'The milky gives your pleasure a secure, sheltered softness.',
    'gourmand→orientalisch':
      'The amber gives your sweetness a mysterious, profound depth.',

    'orientalisch→gourmand':
      'The gourmand gives your depth an indulgent, playful warmth.',
    'orientalisch→wuerzig':
      'The spice gives your mystery a self-assured, bold force.',

    'wuerzig→orientalisch':
      'The amber lends your confidence a mysterious, absorbed resonance.',
    'wuerzig→holzig':
      'The woody gives your courage a stable, steadfast, centered base.',

    'holzig→wuerzig':
      'The spice gives your stability a self-assured, determined edge.',
    'holzig→chypre':
      'The earthy-leather gives your substance a commanding, charismatic presence.',

    'chypre→holzig':
      'The woody deepens your composure into a stable, centered solidity.',
    'chypre→fruchtig':
      'The fruit rounds your charisma with a joyful, exuberant warmth.',
  },

  presence: {
    'intim':
      'Your scent belongs to you alone: a secret on the skin that only those ' +
      'who come truly close will notice.',

    'moderat':
      'Your scent is a quiet signature: there for anyone who comes close enough.',

    'intensiv':
      'Your scent is a presence. Anyone who meets you will catch it ' +
      'and will not forget it any time soon.',

    'statement':
      'Your scent defines the room before the first word is spoken. ' +
      'Your olfactory statement.',
  },

};

window.FRAGRANCE_QUIZ_PROFILES =
  (typeof window !== 'undefined' && window.FQ_LANG === 'en')
    ? window.FRAGRANCE_QUIZ_PROFILES_EN
    : window.FRAGRANCE_QUIZ_PROFILES_DE;
